import { TableCell as SuperTableCell } from '@material-ui/core';
import { TableCellProps } from '@material-ui/core/TableCell';
import React from 'react';

const TableCell = (props: TableCellProps) => {
  if (props.hidden) {
    return null;
  }
  return <SuperTableCell padding="dense" {...props} />;
};

export default TableCell;



// WEBPACK FOOTER //
// ./src/components/Table/TableCell.tsx